import React from 'react';
import { withTranslation } from 'react-i18next';
import {connect} from "react-redux";
import {NavLink} from 'react-router-dom';
import {permissionCleaner, sharedWordRemove, translate} from '../../../../../../utils';
import SharingPreview from '../../../../../../components/sharing-preview';
import {isDragging} from "../../../../../../../actions/dragNDropActions";
import LabelIcon from "./components/label-icon";
import {
    contactsLetter,
    findContacts,
    isLoadingContacts,
    putLabelToAdd
} from '../../../../../../../actions/contactActions';
import {flash, getSharingDetailsPopup} from '../../../../../../../actions/sharingDetailsActions';
import {msgBar} from '../../../../../../../actions/msgBarActions';
import {
	resetStates,
	labelStateUpdating,
	getSelectedContactsGroup,
	selectSeveralContactsGroups, contactLabelsToCollapse, contactLabelsToExpend, labelDropdown
} from '../../../../../../../actions/contactsGroupItemActions';
import SharingLabelButton from './components/sharing-label-button/index';
import Icon from '../../../../../../components/icon';
import {directoryLabelsToCollapse, directoryLabelsToExpend} from '../../../../../../../actions/directoryGroupActions';
import {isOrgUnitAccessPopupShown} from '../../../../../../../actions/popupActions';
import PicButton from '../../../../../../components/pic-button';
import LabelMoreOptionDropdown from "./components/label-more-option-dropdown";
import {isLabelSelectedOnMobile} from '../../../../../../../actions/mobileActions';
import './index.css';

class Label extends React.Component {

	constructor(props){
		super(props);

		this.mouseEnterHandler = this.mouseEnterHandler.bind(this);
        this.mouseUpHandler = this.mouseUpHandler.bind(this);
        this.eyeClickHandler = this.eyeClickHandler.bind(this);
		this.checkboxClickHandler = this.checkboxClickHandler.bind(this);
		this.collapseHandler = this.collapseHandler.bind(this);
		this.extendHandler = this.extendHandler.bind(this);
		this.popupAccessOrgUnitPermissionHandler = this.popupAccessOrgUnitPermissionHandler.bind(this);
		this.handleDropdown = this.handleDropdown.bind(this);
		this.clickHandlerForMobile = this.clickHandlerForMobile.bind(this);

        this.state = {
		    mobileDeviceDetected: false,
		    extendMenu: false
	    }
    }

    mouseEnterHandler(e){
	    if(e.currentTarget.dataset.permission === "READ_ONLY" || e.currentTarget.dataset.type === "directory"){
	    	if(document.querySelector('.drag-info')){
			    document.querySelector('.drag-info').classList.add('error');
		    }
	    } else {
		    if(document.querySelector('.drag-info')){
			    document.querySelector('.drag-info').classList.remove('error');
		    }
	    }
	}

    mouseUpHandler(e){

        this.props.setLabelStateUpdating(e.currentTarget.dataset.id);

		this.props.setIsDragging(false);
		document.querySelectorAll(".drag-n-drop").forEach(item => item.classList.contains("drag-n-drop") ? item.classList.remove("drag-n-drop") : null);

	    if(e.currentTarget.dataset.permission !== "READ_ONLY" && e.currentTarget.dataset.type !== "directory"){
            let invalidAttachment = false;

	        this.props.selectedContactFromDrag.find(item => {

	        	/*
	        	* In case dragged contact is shareable false due to the fact the label the contact is into, is in read-only as well
	        	* */

                if (item.shareable === "false" && item.permission === "READ_ONLY") {
                    invalidAttachment = true;
                }

                return invalidAttachment;
            });

            if(!invalidAttachment){
                this.props.putLabelToAdd([e.currentTarget.dataset], this.props.selectedContactFromDrag, false, e.currentTarget.dataset.name, null, null,null,e.currentTarget.dataset.ownerId);
            } else {
                this.props.flash({type: 'danger', message: translate("msgBarErrorText4").replace("{{labelName}}", e.currentTarget.dataset.name)});
                this.props.setLabelStateUpdating(null);
            }
	    } else {
	    	this.props.flash({type: 'danger', message: translate("msgBarErrorText3").replace("{{labelName}}", e.currentTarget.dataset.name)});
            this.props.setLabelStateUpdating(null);
	    }

    }

    eyeClickHandler(e){
        this.props.flash({type: 'danger', message: translate("msgBarErrorText4").replace("{{labelName}}", e.currentTarget.dataset.name)});
    }

    checkboxClickHandler(e){

	    /*
	    * In order to cancel input automatic check and the propagation issue to parent by bubbling.
	    * */

	    e.preventDefault();
		e.stopPropagation();

		if(this.props.permission === 'OWNER' || this.props.permission === 'CAN_SHARE'){
            let cTarget = e.currentTarget;
            let labelCheckbox = cTarget.previousElementSibling;
            let currentLabel = cTarget.parentElement.parentElement;

            if(!labelCheckbox.checked) {

                labelCheckbox.checked = true;

                if(this.props.selectSeveralContactsGroups.length === 0){

                    this.props.setSelectSeveralContactsGroups([
                        {
                            'id' : currentLabel.dataset.id,
                            'name' : currentLabel.dataset.name,
                            'status' : currentLabel.dataset.status,
                            'permission' : currentLabel.dataset.permission,
	                        'ownerId' : currentLabel.dataset.ownerId
                        }
                    ]);

                } else {

                    this.props.setSelectSeveralContactsGroups([
                        ...this.props.selectSeveralContactsGroups,
                        {
                            'id' : currentLabel.dataset.id,
                            'name' : currentLabel.dataset.name,
                            'status' : currentLabel.dataset.status,
                            'permission' : currentLabel.dataset.permission,
	                        'ownerId' : currentLabel.dataset.ownerId
                        }
                    ]);

                }

                if(!currentLabel.classList.contains('selected')){
                    currentLabel.classList.add('selected');
                }

            } else {
                labelCheckbox.checked = false;

                let filteredSelectedLabels = this.props.selectSeveralContactsGroups.filter(item => item.id !== currentLabel.id);
                this.props.setSelectSeveralContactsGroups(filteredSelectedLabels);

                if(currentLabel.classList.contains('selected')){
                    currentLabel.classList.remove('selected');
                }
            }
        }

		setTimeout( () => {
			if(this.props.selectSeveralContactsGroups.length === document.querySelectorAll('.list-of-group-body .label').length){
				document.getElementById('massLabelsSelection').checked = true;
			} else {
				document.getElementById('massLabelsSelection').checked = false;
			}
		})

	}

	collapseHandler () {
		if (
			this.props.type === "directory"
			|| this.props.type === "childDirectory"
		) {
			this.props.directoryLabelsToCollapse({labelId: this.props.id, labelType: this.props.type, customerId: this.props.customerId});
		} else if (
			this.props.type === "contact"
			|| this.props.type === "childContact"
		) {
			this.props.contactLabelsToCollapse({labelId: this.props.id, labelType: this.props.type});
		}
	}

	extendHandler () {
		if (
			this.props.type === "directory"
			|| this.props.type === "childDirectory"
		) {
			this.props.directoryLabelsToExpend({labelId: this.props.id, labelType: this.props.type, customerId: this.props.customerId});
		} else if (
			this.props.type === "contact"
			|| this.props.type === "childContact"
		) {
			this.props.contactLabelsToExpend({labelId: this.props.id, labelType: this.props.type});
		}
	}

	popupAccessOrgUnitPermissionHandler () {
		this.props.setIsOrgUnitAccessPopupShown(true);
	}

	handleDropdown (e) {
		e.preventDefault();
		e.stopPropagation();
		this.props.setLabelDropdown(this.props.id)
	}

	clickHandlerForMobile () {
		this.props.setIsLabelSelectedOnMobile(true);
	}

	render() {

        let renderCheckbox = true;

        if(["contact_details", "gmail_contact_details"].includes(this.props.sharingDetailsPopup[1]) || this.props.type === 'directory' || this.props.type === 'childDirectory' || this.props.type === 'childDirectoryLv2' || this.props.type === 'system' || this.props.type === 'recent'){
            renderCheckbox = false;
        }

		if(document.querySelectorAll('.label').length > 0){

			/*
			* Drag'n drop appearance
			* */

			if(this.props.isDragging){
				document.querySelectorAll('.label').forEach((item) => {
					item.classList.add('drag-n-drop');
				});
			} else {
				document.querySelectorAll('.label').forEach((item) => {
					item.classList.remove('drag-n-drop');
				});
			}

		}

		/*if(this.props.id === "104710d18ee23e9f"){
			console.log(this.props);
			debugger;
		}*/

		return (
			<NavLink
				to={this.props.type === 'recent' ? `/label/latest-contacts` : `/label/${this.props.id}`}
                className={`label${this.props.type === 'contact' || this.props.type === 'childContact' || this.props.type === 'childContactLv2' ? ' group' : ''} d-flex align-items-center justify-content-between noselect${this.props.permission !== 'READ_ONLY' ? '' : ' read-only'}${this.props.isHidden.includes(this.props.id) || this.props.isContactLabelHidden.includes(this.props.id) ? ' is-hidden' : ''}`}
                onMouseEnter={this.props.isDragging ? this.mouseEnterHandler : null}
                onMouseUp={this.props.isDragging ? this.mouseUpHandler : null}
				onMouseLeave={() => this.props.labelDropdown ? this.props.setLabelDropdown("") : null}
				onClick={ this.props.isMobileOrTabletDetected ? this.clickHandlerForMobile : null }
                id={this.props.id}
                key={this.props.key}
				data-id={this.props.id}
				data-name={this.props.name}
				data-status={this.props.status}
				data-permission={this.props.permission}
				data-type={this.props.type}
				data-active-directory={this.props.activeDirectory}
				data-owner-id={this.props.ownerId}
				data-owner-name={this.props.ownerName}
				data-index={this.props.index}
				data-directory-sync-type={this.props.directorySyncType}
				data-directory-sync-status={this.props.directorySyncStatus}
				data-directory-display-status={this.props.directoryDisplayStatus}
				data-customer-id={this.props.customerId}
                style={this.props.rowStyle}
            >
                {
                    renderCheckbox
                    &&
                    <div className="custom-control custom-checkbox my-1">
	                    <input
                            defaultChecked={this.props.selectSeveralContactsGroups.find(item => item.id === this.props.id)}
                            type="checkbox"
                            data-id={this.props.id}
                            data-type={this.props.type}
                            data-shareable={this.props.shareable}
                            data-permission={this.props.permission}
                            className="custom-control-input"
                            id={`label-checkbox-${this.props.id}`}
                            disabled={this.props.permission === 'READ_ONLY' || this.props.permission === 'WRITE_ONLY' || this.props.permission === 'WRITE_DELETE'}
                            onClick={this.checkboxClickHandler}
	                    />
	                    <label onClick={this.checkboxClickHandler} className="custom-control-label" htmlFor={`label-checkbox-${this.props.id}`}/>
                    </div>
                }
                <div className={`label__name mr-2 flex-grow-1 text-truncate position-relative${(this.props.type === "childDirectoryLv2" || this.props.type === "childContactLv2") ? ' ml-5' : (this.props.type === "childDirectory" || this.props.type === "childContact") ? ' ml-3' : '' }`}>
	                {
		                this.props.noCaret
			            ?
			                null
				        :
			                (
			                	this.props.type === "directory"
				                || this.props.type === "childDirectory"
				                || this.props.type === "childDirectoryLv2"
			                )
			                ?
				                <>
					                {
						                this.props.isCollapsed.includes(this.props.id) || (this.props.profile.accessStatus.isOrgUnitGranted === false && this.props.profile.domain.customerId === this.props.customerId)
							                ?
												<PicButton className="caret" onClick={this.props.profile.accessStatus.isOrgUnitGranted ? this.extendHandler : this.props.profile.domain.customerId === this.props.customerId ? this.popupAccessOrgUnitPermissionHandler : this.extendHandler }>
													<Icon name="caret-right"/>
												</PicButton>
							                :
							                    <PicButton className="caret" onClick={this.collapseHandler}>
								                    <Icon name="caret-down" />
							                    </PicButton>
					                }
				                </>
				            :
				                (
					                this.props.type === "contact"
					                || this.props.type === "childContact"
				                )
		                        ?
									this.props.childContactGroups
									?
										<>
											{
												this.props.isContactLabelCollapsed.includes(this.props.id)
												?
													<PicButton className="caret" onClick={this.extendHandler}>
														<Icon name="caret-right"/>
													</PicButton>
												:
													<PicButton className="caret" onClick={this.collapseHandler}>
														<Icon name="caret-down" />
													</PicButton>
											}
										</>
									:
					                	null
					            :
					                null
	                }
	                {
		                window.innerWidth > 991 && this.props.type !== "childDirectory" && this.props.type !== "childDirectoryLv2" && <LabelIcon type={this.props.type} status={this.props.status}/>
	                }
                    <span className="align-middle mr-1" title={`${sharedWordRemove(this.props.name)} (${permissionCleaner(this.props.permission)})` }>{sharedWordRemove(this.props.name)}</span>
                    <span className="nbr-of-contacts mr-2">{ this.props.type !== "recent" && `(${this.props.nbOfContact})`}</span>
	                {
	                	(
	                		this.props.directorySyncStatus === "RUNNING"
		                    || this.props.labelStateUpdating === this.props.id
		                )
	                    && <Icon animated={'pulse'} name="spinner"/>
	                }
                </div>
                {
                    this.props.sharingPreview
                    ?
                        <SharingPreview
                            permission={this.props.permission}
                            labelId={this.props.id}
                            collaborators={this.props.sharingPreview}
                            sharingNumber={this.props.sharingNumber}
                            status={this.props.status}
                        />
                    :
                        ''
                }
				{
					this.props.selectSeveralContactsGroups.length === 0 && this.props.status === "NOT_SHARED"
					?
						this.props.type === "directory"
						?
							this.props.activeDirectory
                            && (this.props.permission === 'OWNER' || this.props.permission === 'CAN_SHARE')
                            && (this.props.profile.domain?.plan === "BUSINESS")
                            && this.props.directorySyncStatus === "SUCCEED"
							?
								<SharingLabelButton labelId={this.props.id} labelType={this.props.type} title={this.props.t("texthoveronshare")}/>
							:
								<SharingLabelButton labelId={this.props.id} labelType={this.props.type} disabled={true} title={'Share label'}/>
						:
							this.props.permission === 'OWNER' || this.props.permission === 'CAN_SHARE'
							?
								<SharingLabelButton labelId={this.props.id} labelType={this.props.type} title={this.props.t("texthoveronshare")}/>
							:
								<SharingLabelButton labelId={this.props.id} labelType={this.props.type} disabled={true} title={'Share label'}/>
					:
						null
				}
				{
					this.props.type === "system" || this.props.status === "SHARED_WITH_ME"
					|| (this.props.type === "directory" && this.props.activeDirectory === false)
					|| this.props.type === "childDirectory"
					|| this.props.type === "childDirectoryLv2"
					|| this.props.type === "recent"
					?
						null
					:
						<PicButton className="d-flex align-items-center more-options ml-2" onClick={ this.handleDropdown }>
							<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
								<path
									fill="currentColor"
									d="M 12 24 C 11.175 24 10.469 23.706 9.881 23.119 C 9.294 22.531 9 21.825 9 21 C 9 20.175 9.294 19.469 9.881 18.881 C 10.469 18.294 11.175 18 12 18 C 12.825 18 13.531 18.294 14.119 18.881 C 14.706 19.469 15 20.175 15 21 C 15 21.825 14.706 22.531 14.119 23.119 C 13.531 23.706 12.825 24 12 24 Z M 12 15 C 11.175 15 10.469 14.706 9.881 14.119 C 9.294 13.531 9 12.825 9 12 C 9 11.175 9.294 10.469 9.881 9.881 C 10.469 9.294 11.175 9 12 9 C 12.825 9 13.531 9.294 14.119 9.881 C 14.706 10.469 15 11.175 15 12 C 15 12.825 14.706 13.531 14.119 14.119 C 13.531 14.706 12.825 15 12 15 Z M 12 6 C 11.175 6 10.469 5.706 9.881 5.119 C 9.294 4.531 9 3.825 9 3 C 9 2.175 9.294 1.469 9.881 0.881 C 10.469 0.294 11.175 0 12 0 C 12.825 0 13.531 0.294 14.119 0.881 C 14.706 1.469 15 2.175 15 3 C 15 3.825 14.706 4.531 14.119 5.119 C 13.531 5.706 12.825 6 12 6 Z"/>
							</svg>
						</PicButton>
				}
				{
					this.props.labelDropdown === this.props.id && this.props.type !== "system" &&
					<LabelMoreOptionDropdown
						id={this.props.id}
						name={this.props.name}
						type={this.props.type}
						status={this.props.status}
						activeDirectory={this.props.activeDirectory}
						permission={this.props.permission}
						directorySyncStatus={this.props.directorySyncStatus}
					/>
				}
			</NavLink>
		);
	}
}

const mapStateToProps = (state) => {
    return {
	    profile : state.profileReducer.getProfile,
        isDragging: state.dragNDropReducer.isDragging,
        selectedContactFromDrag: state.contactReducer.selectedContactFromDrag,
        labelsOfSelectedContacts: state.contactReducer.labelsOfSelectedContacts,
        labelStateUpdating: state.contactsGroupItemReducer.labelStateUpdating,
	    selectSeveralContactsGroups: state.contactsGroupItemReducer.selectSeveralContactsGroups,
        contactsPageSize: state.contactReducer.contactsPageSize,
        sharingDetailsPopup: state.sharingDetailsReducer.getSharingDetailsPopup,
	    contactsLetter: state.contactReducer.contactsLetter,
        isMobileOrTabletDetected: state.mobileReducer.isMobileOrTabletDetected,
	    isLabelSelectedOnMobile: state.mobileReducer.isLabelSelectedOnMobile,
	    isCollapsed: state.directoryGroupReducer.isCollapsed,
	    isHidden: state.directoryGroupReducer.isHidden,
		isContactLabelCollapsed: state.contactsGroupItemReducer.isContactLabelCollapsed,
		isContactLabelHidden: state.contactsGroupItemReducer.isContactLabelHidden,
		labelDropdown: state.contactsGroupItemReducer.labelDropdown
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
	    isLoadingContacts: (boolean) => {
	    	dispatch(isLoadingContacts(boolean))
	    },
        resetStates : (string) => {
			dispatch(resetStates(string))
		},
        getSelectedContactsGroup : (object) => {
            dispatch(getSelectedContactsGroup(object))
        },
        getSharingDetailsPopup : (array) => {
            dispatch(getSharingDetailsPopup(array))
        },
        setIsDragging : (object) => {
            dispatch(isDragging(object))
        },
        putLabelToAdd : (labelIds, contactIds, forceSelection, target,  targetContact, directContactShare, finishFirstLabelSharing, ownerId) => {
            dispatch(putLabelToAdd(labelIds, contactIds, forceSelection, target,  targetContact, directContactShare, finishFirstLabelSharing, ownerId))
        },
	    flash : (array) => {
		    dispatch(flash(array))
	    },
	    msgBar : (array) => {
		    dispatch(msgBar(array))
	    },
        setFindContacts : (contactsGroupId, pageSize) => {
            dispatch(findContacts(contactsGroupId, pageSize))
        },
        setLabelStateUpdating : (labelId) => {
            dispatch(labelStateUpdating(labelId))
        },
	    setSelectSeveralContactsGroups : (array) => {
		    dispatch(selectSeveralContactsGroups(array))
	    },
        setContactsLetter : (string) => {
        	dispatch(contactsLetter(string))
		},
	    directoryLabelsToCollapse: (object) => {
		    dispatch(directoryLabelsToCollapse(object))
	    },
	    contactLabelsToCollapse: (object) => {
		    dispatch(contactLabelsToCollapse(object))
	    },
	    directoryLabelsToExpend: (object) => {
		    dispatch(directoryLabelsToExpend(object))
	    },
		contactLabelsToExpend: (object) => {
			dispatch(contactLabelsToExpend(object))
		},
	    setIsOrgUnitAccessPopupShown: (boolean) => {
		    dispatch(isOrgUnitAccessPopupShown(boolean))
	    },
		setLabelDropdown: (string) => {
			dispatch(labelDropdown(string))
		},
	    setIsLabelSelectedOnMobile: (boolean) => {
	    	dispatch(isLabelSelectedOnMobile(boolean))
	    }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Label));
